var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepeatOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    id: "svg10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 6.875L17.5 5L15.625 3.125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 8.67392 3.02678 7.40215 3.96447 6.46447C4.90215 5.52678 6.17392 5 7.5 5H17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 13.125L2.5 15L4.375 16.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C17.5 11.3261 16.9732 12.5979 16.0355 13.5355C15.0979 14.4732 13.8261 15 12.5 15H2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.1298828,9.2163086 8.9189453,8.855957 10.290039,7.8510742 h 0.363281 v 3.3134768 q 0,0.08203 -0.0029,0.161133 0,0.0791 -0.0029,0.152343 -0.0029,0.07031 -0.0088,0.128907 -0.0029,0.05859 -0.0088,0.09668 l 0.451172,-0.01758 v 0.462891 H 9.3583984 v -0.395508 q 0.099609,-0.0059 0.178711,-0.01758 0.082031,-0.01465 0.1347656,-0.06445 0.055664,-0.05273 0.084961,-0.155274 0.029297,-0.102539 0.029297,-0.284179 V 8.8266602 Z",
    fill: "white",
    strokeWidth: 0.101834,
    "aria-label": 1,
    id: "path2990"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatOne);
export default __webpack_public_path__ + "static/media/repeat-one.4936bb65b294c67777d2151bf8eb6e08.svg";
export { ForwardRef as ReactComponent };